module.exports = __webpack_public_path__ + "static/media/drawer_phone_active.19ce3245.svg";